// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"55a6f5e0","611":"b33d0a8b","739":"b38d02c9","978":"119200ac"}[chunkId] + ".chunk.js";
};